import ApiClient from "./ApiClient";
import PaymentRequestStatus from "../models/payment-request-status/PaymentRequestStatus";

export default class PaymentRequestStatusApiClient {
  apiClient: ApiClient;
  urlPrefix: string = "payment-request-statuses/";

  constructor() {
    this.apiClient = new ApiClient();
  }

  async getStatusesForSelect() {
    const statuses = await this.apiClient.get(this.urlPrefix + 'admin-select');

    return statuses as Array<PaymentRequestStatus>;
  }
}
